module.exports = __webpack_public_path__ + "media/images/folder_collapse-a8dc0a57d615ee13aa63fccf485b75cc.svg";